import { groupBy } from "../../../../helpers";
import { getAudit } from "../../../../services";
import { useCallback, useEffect, useState } from "react";
import { AuthUser, Dossier, Establishment } from "../../../../types";
import { OnlyDateString } from "../../../../lib";
import { Grid } from "@mui/material";
import AuditListCard from "./AuditListCard";

type AuditPropsType = {
    dossierId: number | null;
    establishment: Establishment | null;
};

export type Action = {
    id: number;
    name: string;
    code: string;
    description: string;
};

export type AuthUserOmit = Omit<AuthUser, "establishment"> & {
    establishment: Establishment;
};

export type AuditItem = {
    id: number;
    action: Action;
    user: AuthUserOmit;
    createdAt: string;
    dossier?: Dossier;
};

type GroupedAudit = {
    [date: string]: AuditItem[];
};

export default function Audit({ dossierId, establishment }: AuditPropsType) {
    const [auditInfos, setAuditInfos] = useState<AuditItem[]>([]);

    const fetchAuditInfos = useCallback(async () => {
        if (dossierId) {
            let auditRes = await getAudit(dossierId);
            if (!auditRes.detail) {
                const auditHavingEstablishementIndex = auditRes.findIndex(
                    (a: any) => a.user.establishment
                );
                if (auditHavingEstablishementIndex !== -1) {
                    auditRes[auditHavingEstablishementIndex] = {
                        ...auditRes[auditHavingEstablishementIndex],
                        user: {
                            ...auditRes[auditHavingEstablishementIndex].user,
                            establishment,
                        },
                    };
                }

                setAuditInfos(auditRes);
            }
        }
    }, []);

    const auditGroupedByDate: GroupedAudit | null = auditInfos.length
        ? groupBy(auditInfos, (audit: AuditItem) =>
              OnlyDateString(audit.createdAt)
          )
        : null;

    useEffect(() => {
        if (dossierId) {
            fetchAuditInfos();
        }
    }, []);

    return (
        <>
            {auditGroupedByDate ? (
                <Grid container spacing={2}>
                    {Object.values(auditGroupedByDate).map(
                        (auditListPerDate: AuditItem[], index: number) => {
                            return (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    key={index}
                                    sx={{
                                        display: "flex",

                                        alignItems: "flex-start",
                                        gap: "1rem",

                                        flexDirection: "column",
                                        width: "100%",
                                    }}
                                >
                                    <AuditListCard
                                        auditList={auditListPerDate}
                                    />
                                </Grid>
                            );
                        }
                    )}
                </Grid>
            ) : null}
        </>
    );
}
